import { useCallback } from 'react';
import { useWindowEvent } from './use-window-event';

export function useWindowKeydown(
  targetKey: string,
  callback: (event: WindowEventMap['keydown']) => void
) {
  const callbackWithCheck = useCallback(
    (event: WindowEventMap['keydown']) => {
      const { key } = event;
      if (key === targetKey) {
        callback(event);
      }
    },
    [targetKey, callback]
  );

  return useWindowEvent('keydown', callbackWithCheck);
}
